export const HOME = "/";
export const CONTACT = "/contact";
export const ABOUT = "/about";
export const PRIVACY = "/privacy";
export const TERMS = "/terms_and_cond";
export const PRODUCTS = "/products";
export const UNDER_CONSTRUCTION = "/under-construction";

export const PRICING = "/pricing";
export const LOGIN = "/auth/login";
export const LOGIN_CONFIRM = "/auth/login/:confirmationCode";
export const SIGNUP = "/auth/register";
export const SIGNUP_INDIVIDUAL = "/auth/register/individual";
export const SIGNUP_BUSINESS = "/auth/register/business";
export const FORGOT_PASSWORD = "/auth/forgot-password";
export const RESET_PASSWORD = "/token/:token";
export const CHANGE_PASSWORD = "/auth/change-password";

export const DASHBOARD = "/dashboard";
export const BROADCASTCHANNEL = "/dashboard/broadcast-channel";
export const CALENDAR = "/dashboard/calendar";
export const REFER_A_FRIEND = "/dashboard/invites";
export const SIGNUP_INVITE = `${REFER_A_FRIEND}/:refId`;
export const SETTINGS = "/dashboard/settings";
export const SCHEDULE = "/dashboard/schedule";
export const STARTMEETING = "/dashboard/start-meeting";

// Setting tabs routes
export const PROFILE = "/auth/users/:id";
export const BILLING = "";
export const FILES = "";
export const SECURITY = "";
export const OTHERS = "";
